import React, { useState, useEffect } from 'react';

import API from 'API';

import Switch from 'UI/Switch/Switch';
import SingleNotify from './SingleNotification';

import styles from './NotificationCenter.module.scss';

const NotificationCenter = ({ notifications, clearNotifications, show }) => {
    const [doNotDisturb, setDoNotDisturb] = useState(false);

    const getDoNotDisturb = async () => {
        try {
            const resp = await API.get('/users/privacy_settings');
            const { data } = resp.data;

            setDoNotDisturb(data.do_not_disturb);
		} catch (error) {
			// eslint-disable-next-line
            console.log(error);
        }
    };

    const handleDoNotDisturb = async () => {
        setDoNotDisturb(!doNotDisturb);

        const payload = { do_not_disturb: !doNotDisturb };

        try {
            await API.post('/users/privacy_settings', payload);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    };

    useEffect(() => {
        getDoNotDisturb();
    }, []);

    return (
        <div
            className={[
                styles.notification_center_container,
                show ? styles.close : styles.open,
            ].join(' ')}
        >
            <div className={styles.arrow}></div>
            <header>
                <div className={styles.do_not_disturb}>
                    <p>Do not disturb</p>
                    <Switch
                        name="do-not-disturb"
                        changed={handleDoNotDisturb}
                        value="disturb"
                        checked={doNotDisturb}
                    />
                </div>
                <div className={styles.header}>
                    Notifications
                    <span onClick={clearNotifications}>Clear All</span>
                </div>
            </header>
            <section className={styles.notifications_list}>
                {notifications.length !== 0 ? (
                    <>
                        {notifications.map((list, i) => {
                            return <SingleNotify data={list} key={i} />;
                        })}
                    </>
                ) : (
                    <p className={styles.no_notifications}>No notifications</p>
                )}
            </section>
        </div>
    );
};

export default NotificationCenter;
